var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mu-row',{staticClass:"text-center"},[_c('mu-col',[_c('h3',{staticClass:"m-2"},[_vm._v(_vm._s(_vm._f("capital_Letter")(_vm.title)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }